import { ContentPage } from '@malesia/react-components/dist/src/components/ContentPage/ContentPage';
import { HtmlBlock } from '@malesia/react-components/dist/src/components/Front/HtmlBlock/HtmlBlock';
import { SFC } from '@malesia/react-components/dist/src/types/react';
import React from 'react';
import { useIntl } from 'react-intl';
import useSWR from 'swr';
import { loadContactKosovoPageContent } from '../../services/directus/contactKosovoPage/loadContactKosovoPageContent';

export const MalesiaContactKosovoPage: SFC = () => {
    const { locale } = useIntl();
    const { data } = useSWR([locale, 'loadContactKosovoPageContent'], loadContactKosovoPageContent);

    return (
        <>
            <ContentPage
                image={data?.topImage}
            >
                <HtmlBlock content={data?.content ?? ''} />
            </ContentPage>
        </>
    );
};
